// extracted by mini-css-extract-plugin
export default {"narratives-chat-canvas":"NarrativesCanvas_narratives-chat-canvas__IoNgq"};